import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, Crown, ArrowRight, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { getFeaturedJobStatus } from '@/lib/api';

const FeaturedJobSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!sessionId) { setLoading(false); return; }
    (async () => {
      try {
        const res = await getFeaturedJobStatus(sessionId);
        setStatus(res.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    })();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <section className="pt-32 pb-20">
        <div className="max-w-lg mx-auto px-4">
          <Card className="shadow-lg" data-testid="featured-job-success-card">
            <CardContent className="p-10 text-center">
              {loading ? (
                <Loader2 className="h-12 w-12 animate-spin text-amber-500 mx-auto" />
              ) : status?.payment_status === 'paid' ? (
                <>
                  <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <CheckCircle className="h-8 w-8 text-amber-600" />
                  </div>
                  <h1 className="font-heading text-2xl font-bold text-slate-900 mb-2">Job Featured!</h1>
                  <p className="text-slate-600 mb-6">
                    Your job is now pinned at the top of the Jobs Board with a gold border for 30 days.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <Link to="/jobs">
                      <Button className="bg-gradient-to-r from-amber-500 to-yellow-600 hover:from-amber-600 hover:to-yellow-700 text-white">
                        View Jobs Board <ArrowRight className="h-4 w-4 ml-2" />
                      </Button>
                    </Link>
                    <Link to="/">
                      <Button variant="outline">Back to Home</Button>
                    </Link>
                  </div>
                </>
              ) : (
                <>
                  <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <Crown className="h-8 w-8 text-amber-600" />
                  </div>
                  <h1 className="font-heading text-2xl font-bold text-slate-900 mb-2">Processing Payment</h1>
                  <p className="text-slate-600 mb-6">
                    Your payment is being processed. Your job will be featured shortly.
                  </p>
                  <Link to="/jobs">
                    <Button variant="outline">View Jobs</Button>
                  </Link>
                </>
              )}
            </CardContent>
          </Card>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default FeaturedJobSuccessPage;
